import { Component,  OnDestroy, OnInit } from '@angular/core';
import * as assetActions from "../../../ngrx/act.action";
import { Store } from '@ngrx/store';
import { Location } from '@angular/common';
import { forkJoin, of, Subscription, throwError } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { NavigationEnd, Router, NavigationSkipped } from '@angular/router';
import { LivewalkTestService } from 'src/app/components/actionability/livewalk-test/livewalk-test-service';
import { FloorMapAddModelComponent } from 'src/app/components/administration/floor-map-add-model/floor-map-add-model.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MnoMappingEditComponent } from 'src/app/components/administration/mno-mapping/mno-mapping-edit/mno-mapping-edit.component';
import { GroupsManagerAddModelComponent } from 'src/app/components/administration/groups-manager/groups-manager-add-model/groups-manager-add-model';
import { ImportPopupComponent } from 'src/app/components/administration/floor-maps-manager/import-popup/import-popup.component';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../../services/shared.service';
import { UserAddComponent } from 'src/app/components/administration/users/user-add/user-add.component';
import { faTerminal } from '@fortawesome/free-solid-svg-icons';
import { CustombaseComponent } from 'src/app/custombase/custombase.component';
import { RoleAddComponent } from 'src/app/components/administration/role-manager/role-add/role-add.component';
import { catchError } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { MnoMapModelComponent } from 'src/app/components/administration/mno-mapping/mno-mapping-list/mno-map-model.component';
import { faWifi } from '@fortawesome/free-solid-svg-icons';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-action-buttons',
  templateUrl: './action-buttons.component.html',
  styleUrls: ['./action-buttons.component.scss'],
  providers: [NgbActiveModal] 
})
export class ActionButtonsComponent extends CustombaseComponent implements OnInit, OnDestroy {
  faInfoCircle = faInfoCircle;
  matDialogRef: MatDialogRef<FloorMapAddModelComponent>;
  matDialogRef2: MatDialogRef<GroupsManagerAddModelComponent>;
  matDialogRef1: MatDialogRef<MnoMappingEditComponent>;
  matDialogRef3: MatDialogRef<ImportPopupComponent>;
  matDialogRef4: MatDialogRef<RoleAddComponent>;
  faWifi=faWifi;
  fetchingDevices=false;
  fetchingMaps = false;
  faTerminal = faTerminal
  openAddDeviceModal = false;
  openUpgradeModal: boolean;
  openSetAPNModal: boolean;
  openDeleteModal: boolean;
  openRebootModal: boolean;
  openSetWifiModal: boolean;
  isAllow: boolean = false
  subscrptions: Subscription[] = [];
  multipleSettings1: any = {};
  multipleSettings3: any = {};
  multipleSettings2: any = {}
  multipleSettings5: any = {};
  singleSettings: any = {};
  eventTypes: any[] = [];
  selectedEventType = [];
  deviceApiCallThrottlingtimeout:any;
  deviceApiCallThrottlingtimeoutCopy:any;
  datetimeRange:any;
  tests = [{ name: 'Quick Test', id: 'Quick Test' }, { name: 'Deep Test', id: 'Deep Test' }, { name: 'IPERF Test', id: 'IPERF Test' }, { name: 'Continuous Test', id: 'Continuous Test' }]
  selectedTestType!: string
  devices = [] as any;
  devicesReprt:any=[]
  selectedDevice: any[] = [];
  selectedReportDevice:any[]=[];
  displayActions = false;
  imeiDropdown = false;
  walktestActions = false
  eventTypeShow = false;
  showTestTypeDropdown = false
  maplist = [{ id: 2222, name: 'No Maps', catagory: 'Indoor' }]
  selectedMap: any[] = []
  pageName: any;
  disableWalktestActions: false
  disableSubscription: any
  subjectObserver: any
  joinLiveSubscribeInstance: any;
  notificationDevices: any[] = [];
  previousSelectedDevice: any;
  previousSelectedMap: any;
  selectedNotificationDevice: any;
  allDevices: any = {};
  deviceStatus: boolean = false;
  devicetatusInfo:boolean=false
  isLaunched = false;
  isDetailedReport=false;
  disableDetailedSubmit = false;
  currentUrl:any;
  user_type: string;
  mabSubscription:any;
  mapReloadObservableSubscription:any;
  dateRangeObjSubscription:any;
  allsubscriptions:any = [];
  allDevicesSubscription:any;
 deviceInfoSubscription:any;
 loadDataSubscription:any
 openBandlockInfo={check:false,size:"lg"};
 walktestMaplist:any=[];
  redirectAction = false;;
  showBackButton = false;
  constructor(private store: Store<any>, private telemetryService: SharedService, public authService: AuthService, private router: Router, private matDialog: MatDialog,
    private walktestServices: LivewalkTestService, private dialog: MatDialog, private commonServices: CommonService, private modalService: NgbModal,  private location: Location,
    private toast:ToastrService) {
    super()
    // Load previousSelectedDevice from localStorage
    const storedDevice = localStorage.getItem('previousSelectedDevice');
    if (storedDevice && storedDevice != "undefined") {
      this.previousSelectedDevice = storedDevice ? JSON.parse(storedDevice) : null;
      
    } else {
      this.previousSelectedDevice = null;
    }
    const storedMap = localStorage.getItem('previousSelectedMap');
    if (storedMap && storedMap != "undefined") {
      this.previousSelectedMap = storedMap ? JSON.parse(storedMap) : null;
      this.selectedMap=this.previousSelectedMap;
    } else {
      this.previousSelectedMap = null;
    }
    let val=0;
    this.router.events.subscribe((event: any) => {
  
      this.currentUrl = event?.url;
      // //console.log(event, 'kkkkkkkkkkkxkkk', event instanceof NavigationSkipped);
      this.modalService.dismissAll() //this is for closing all pop ups when rout changes
      // this.disableSubscription&&this.disableSubscription.unsubscribe()
      // this.maplist = [{ id: 2222, name: 'No Maps', catagory: 'Indoor' }];
      // this.selectedMap = [{}];
      // this.selectedDevice = [{}];
      // this.authService.sendDeviceInfo(this.selectedDevice);
      // this.devices = []

      if (event instanceof NavigationEnd || event instanceof NavigationSkipped) {
        if (this.location.getState()?.['isNavigatedfromTest']) {
           // Load previousSelectedDevice from localStorage
    const storedDevice = localStorage.getItem('previousSelectedDevice');
    if (storedDevice && storedDevice != "undefined") {
      this.previousSelectedDevice = storedDevice ? JSON.parse(storedDevice) : null;
      this.selectedDevice = this.previousSelectedDevice ? [this.previousSelectedDevice] : [];
    } else {
      this.previousSelectedDevice = null;
    }
          this.showBackButton = true;
        } else {
          this.showBackButton = false;
        }
        //console.log(val," llll ",event.url,"kkkkkkkkkkkk");
        val++;
        this.isDetailedReport = false;
        // //console.log(event.url, 'kkkkkkkkkkkkkk')
        if(this.isLaunched){
          if(event.url != '/live-walk-test'){
            localStorage.removeItem("token");
            this.router.navigate(['/login']);
          }
        }
        if (event.url == '/assets') {
          this.displayActions = true;
          this.imeiDropdown = false;
          this.walktestActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

        } else if (event.url == '/telemetry') {
          this.imeiDropdown = true;
          this.displayActions = false;
          this.walktestActions = false;
          this.eventTypeShow = false;
          this.redirectAction = true;
        } else if (event.url == '/device-configuration' || event.url=='/gps-report') {
          this.imeiDropdown = true;
          this.displayActions = false;
          this.walktestActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

          //console.log(this.selectedDevice);
          // this.getDevices('telemetry');
        }
         else if (event.url == '/data-model') {
          this.imeiDropdown = true;
          this.displayActions = false;
          this.walktestActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

          // this.loadInitialData();
          // this.getDevices('data-model')
        } else if (event.url == '/global-notifications') {
          this.walktestActions = false;
          this.imeiDropdown = false;
          this.showTestTypeDropdown = false;
          this.displayActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

        }
        else if (event.url == '/walktest-report-table') {
          this.walktestActions = false;
          this.imeiDropdown = false;
          this.showTestTypeDropdown = false;
          this.displayActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

        }
        else if (event.url == '/kpidashboard') {
          this.imeiDropdown = true;
          this.walktestActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

        } else if (event.url == '/live-walk-test') {

          // this.getDevices('live-walk-test');
          //console.log("ooooooooooooooooooo");
          this.walktestActions = true;
          this.imeiDropdown = true;
          this.showTestTypeDropdown = true
          this.displayActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

          this.disableSubscription = walktestServices.getDesableObs().subscribe((res: any) => {
            console.log(res);
            this.disableWalktestActions = res
            this.multipleSettings2 = { ...this.multipleSettings2, disabled: res };
            this.multipleSettings1 = { ...this.multipleSettings1, disabled: res };
          })
          // this.loadInitialData()
        }
        else if (event.url == '/live-walk-test/walktest-scheduler'||event.url == '/live-walk-test/device-logs') {
          this.walktestActions = false;
          this.imeiDropdown = true;
          this.showTestTypeDropdown = true
          this.displayActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

          // this.loadInitialData()
          this.changeMap();
        }
        else if (event.url == '/dashboard') {
          this.walktestActions = false;
          this.imeiDropdown = false;
          this.showTestTypeDropdown = false;
          this.displayActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

        }
        else if (event.url == '/walktest-detailed-report') {
          this.isDetailedReport=true;
          this.walktestActions = false;
          this.imeiDropdown = true;
          this.showTestTypeDropdown = false
          this.displayActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

          // this.selectedDevice=[];
          this.selectedMap=[];
          // this.devices=[];
          this.maplist=[];
          // this.loadInitialData()
        }
        else if (event.url == '/edge-intelligence') {
          this.walktestActions = false;
          this.imeiDropdown = true;
          this.displayActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

          // this.getDevices('data-model')
        }
        else if (event.url == '/signal-heatmap') {
          this.imeiDropdown = true;
          this.walktestActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

        }
        else if (event.url == '/geo-fence') {
          this.imeiDropdown = false;
          this.walktestActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

          // this.getDevices('geo-fence')
        }
        else if (event.url == '/edge-geo-fencing-control') {
          this.imeiDropdown = true;
          this.eventTypeShow = false;
          this.redirectAction = false;

        }
        else if (event.url == '/devices-setup/setup') {
          this.walktestActions = false;
          this.imeiDropdown = true;
          this.showTestTypeDropdown = false;
          this.displayActions = false;
          this.eventTypeShow = false
          this.redirectAction = false;

          this.changeMap();
          // this.getDevices('live-walk-test');
        }
       else if (event.url == '/video-stream') {
          this.displayActions = false;
          this.imeiDropdown = true;
          this.walktestActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

        }
        else {
          this.imeiDropdown = false;
          this.displayActions = false;
          this.walktestActions = false;
          this.eventTypeShow = false;
          this.redirectAction = false;

        }
        this.selectedReportDevice=[];
        this.devicesReprt=[];
      }
    });
    let pageNameSubscrptn$:any = this.authService.pageName.subscribe(x => {
      this.pageName = x;
    }
    );

    this.allsubscriptions.push(pageNameSubscrptn$);
  }
  ngOnDestroy(): void {
    try{
      this.loadDataSubscription&&this.loadDataSubscription.unsubscribe();
      this.deviceInfoSubscription&&this.deviceInfoSubscription.unsubscribe();
      this.mabSubscription&& this.mabSubscription.unsubscribe();
      this.mapReloadObservableSubscription&&this.mapReloadObservableSubscription.unsubscribe();
      this.dateRangeObjSubscription&&this.dateRangeObjSubscription.unsubscribe();
      if(this.allsubscriptions){
        for(let subscription of this.allsubscriptions){
          //console.log(subscription)
               if(subscription){
                subscription.unsubscribe();
                  }
            }
      }
      this.allsubscriptions=[];
    }catch(err){
      //console.log(err)
    }

  }

  ngOnInit(): void {
//console.log("action button called");
   let mapObjecSubscrptn$:any =  this.authService.mapObj.subscribe(map => {
      this.selectedMap = map;
    })

    this.allsubscriptions.push(mapObjecSubscrptn$);

   this.deviceInfoSubscription = this.store.select('reloadActions').subscribe(res => {
      //console.log(res);
      this.loadInitialData()
    }
  )
  this.user_type = localStorage.getItem('user_type');


    this.multipleSettings1 = {
      text: "Select An Serial Number",
      classes: "myclass custom-class large-text-handle",
      enableSearchFilter: true,
      singleSelection: true,
      labelKey: "serial_name",
      badgeShowLimit: 1
    };

    this.multipleSettings3 = {
      text: "Select Event Type",
      classes: "myclass custom-class large-text-handle",
      enableSearchFilter: true,
      singleSelection: true,
      labelKey: "type_name",
      badgeShowLimit: 1
    };
    this.multipleSettings5 = {
      text: "Select An Serial Number",
      classes: "myclass custom-class large-text-handle",
      enableSearchFilter: true,
      singleSelection: true,
      labelKey: "deviceid",
      badgeShowLimit: 1
    };

    this.multipleSettings2 = {
      text: "Select a Map",
      classes: "myclass custom-class large-text-handle",
      enableSearchFilter: true,
      singleSelection: true,
      labelKey: "name",
      badgeShowLimit: 1,
      // groupBy:'catagory',
    };

    this.singleSettings = {
      text: "Test Type",
      classes: "myclass custom-class large-text-handle",
      enableSearchFilter: false,
      singleSelection: true,
      labelKey: "name",
      badgeShowLimit: 1
    };///
    // this.getEventTypes();
    // this.getDevices('telemetry');
    // this.store.select('disableActions').subscribe(res=>{
    //   //console.log(res)
    //        this.disableWalktestActions = res?.disableActions
    // })

    this.joinLiveSubscribeInstance = this.walktestServices.joinLiveSubject.subscribe(res => {
      //console.log(res)
      this.selectedDevice = res?.selectedDevice;
      this.selectedMap = res?.selectedMap;
    })

     let reload$ =this.authService.mapReloadObservable.subscribe(res => {
      this.getMaps(true, "1");
    })
    this.allsubscriptions.push(reload$)

    let daterange$ = this.authService.dateRangeObj.subscribe(x => {
      if(this.isDetailedReport){
        this.datetimeRange = {start:new Date(x.startDate).valueOf(), end:new Date(x.endDate).valueOf()};
        this.getMaps({startDate: new Date(x.startDate).valueOf(), endDate: new Date(x.endDate).valueOf()},'2')
      }
    }); 

    this.allsubscriptions.push(daterange$) 

  //  let selectedDeviceObservable$ =this.authService.getDeviceInfo().subscribe(res=>{
  //     //console.log("acion buttonts ", res);
  //     this.selectedDevice=res;
  //   });
    
  //   this.allsubscriptions.push(selectedDeviceObservable$);

    this.loadDataSubscription  = this.commonServices.reloadData.subscribe(res=>{
      if(res?.execute=='asset'){
               this.getDevices("asset"); 
    }
  })

  }
  //   getEventTypes() {
  //     this.commonServices.getEventTypes().subscribe((data: any) => {
  //       let value = []
  //       data?.['result']['events'].forEach((item, index) => {
  //         value.push({ id: index, type: item, type_name: item })
  //     })
  //     this.eventTypes = value;
  //     this.notificationDevices = data?.['result']['devices'];
  //   })
  // }

  addDevice() {
    this.store.dispatch(new assetActions.assetsActions({ addDevice: true }));
  }
  generateReport(){   this.store.dispatch(new assetActions.gpsReportAction({ loadReport: true }));}
  setWifi() {
    this.store.dispatch(new assetActions.assetsActions({ setWifi: true }));
  }
  openCommandPrompt() {
    this.store.dispatch(new assetActions.assetsActions({ setPrompt: true }));
  }
  onReboot() {
    this.store.dispatch(new assetActions.assetsActions({ reboot: true }));
  }
  delete() {
    this.store.dispatch(new assetActions.assetsActions({ delete: true }));
  }
  setApn() {
    this.store.dispatch(new assetActions.assetsActions({ setApn: true }));
  }
  upGrade() {
    this.store.dispatch(new assetActions.assetsActions({ upgrade: true }));
  }
  startTest() {
    this.store.dispatch(new assetActions.walktestActions({ showStartTest: true }))
  }

  stopTest() {
    this.store.dispatch(new assetActions.walktestActions({ showStopTest: true }))

  }
  openOnGoing() {
    this.store.dispatch(new assetActions.walktestOpenDeviceStatus({ showOngoingTests: true }))
  }

  openTestConfigurations() {
    this.authService.testConfigurationPopup.next({open:"testconfig_livewalktest"});
  }
  isDispatchCalled = false;
  onClickDevicetatus(){
    if (!this.isDispatchCalled) {
  this.store.dispatch(new assetActions.deviceStatusInfo({   opePopUp:true }));
  this.isDispatchCalled = true;
    }
    setTimeout(() => {
      this.isDispatchCalled = false;
    }, 1000);
  }
  handleDetailedReport() {
    if(this.selectedMap?.[0]){
      this.disableDetailedSubmit=true;
      this.walktestServices.getCurrentInstanceOfTriggeredDetailedSubmit().next({})
      let out = setTimeout(()=>{
        this.disableDetailedSubmit=false;
        clearTimeout(out)
      },2000)
    }else{
            this.toast.warning("Map is not selected");
    }
  
  }

  loadInitialData() {
    this.subjectObserver && this.subjectObserver.unsubscribe()
    this.subjectObserver = this.commonServices.reroutingSubject.subscribe(res => {
      
      //console.log(this.currentUrl,res, 'oooooooooooooooooooooooooooooooooooo')
      if (res?.type == 'launch') {
        this.isLaunched = true;
        
          this.authService.sendMapInfo([{ id: res?.mapid, mapid: res?.mapid, name: res?.mapname, file: res?.file, catagory: 'Indoor' }])
          //console.log(res, 'iiiiiiiiiiiiiiiiiiiiiiiiiiiiii')
        
      this.selectedDevice = [{ id: res?.deviceid, serial: res?.deviceid, serial_name:`${res?.deviceid} (${res?.devicename})` }];
      //console.log(this.selectedDevice, "called loadinitialData");
        this.authService.sendDeviceInfo([{ id: res?.deviceid, serial: res?.deviceid, serial_name:`${res?.deviceid} (${res?.devicename})`  }]);
      }
      else {
        if (this.currentUrl!="/walktest-report") {
        this.getMaps(undefined, "3")}
      }
      this.getDevices(res?.type, "dummy")

    })
  }
  

  getDevices(check: any, check2?:any) {
    this.allDevicesSubscription&&this.allDevicesSubscription.unsubscribe();
    // //console.log(check, check2);
     let allDevices$ = this.walktestServices.getAllDevices().subscribe(devices=>{
      // // //console.log(devices)
      // if(devices){
      //   this.allDevices = {...this.allDevices,...devices}
      // }
      const newMap = {};
      if (devices) {
        for(let each in devices){
          if(devices?.[each]?.['platform_serial']){
            if( !newMap[devices?.[each]?.['platform_serial']]){
              devices[each]['serial']=each
              newMap[devices?.[each]?.['platform_serial']] = devices?.[each];
  
            }else{
              let oldtime =  newMap[devices?.[each]?.['platform_serial']]?.platform_heartbeat;
              let newtime =  devices?.[each]?.platform_heartbeat;
              if(newtime>oldtime){   //check which is the latest platform
                devices[each]['serial']=each
                newMap[devices?.[each]?.['platform_serial']] = devices?.[each];
              }
            }
          }
          
        }
        this.allDevices = { ...this.allDevices, ...devices, ...newMap };
      }
    });

    this.allsubscriptions.push(allDevices$)


     let getDeviceName$ = this.telemetryService.getDivecename().subscribe((data: any) => {
      // console.log(data);
      this.commonServices.getoNAList().subscribe({next:(ona:any)=>{
        //console.log(ona);
        const onaMap={};
        if(ona?.result?.hits){
          ona?.result?.hits.map((eachOna:any)=>{
              onaMap[eachOna?._id]=eachOna?._source
          })
        }
   if(data?.result){
    data.result['onaData']=onaMap;
    this.allDevicesSubscription = this.walktestServices.sendAllDevices(data?.result);
   }
 },
      error:(err)=>{
      this.allDevicesSubscription = this.walktestServices.sendAllDevices(data?.result);
      }})
      // this.allDevicesSubscription = this.walktestServices.sendAllDevices(data?.result);
      this.allsubscriptions.push(this.allDevicesSubscription);
      //console.log(data?.result);
      if (check != 'launch') {
        const deviceArr = [];
        let ind = 1
        for (const each in data?.result) {
          const heartbeat = data?.result?.[each]?.heartbeat_ts;
          deviceArr.push({ serial: each, id: each,deviceid: each, serial_name: `${each} (${data?.result?.[each]?.device_name})`, 
                           name: data?.result?.[each]?.device_name, 
                           modems: data?.result?.[each]?.modems, 
                           device_if: data?.result?.[each]?.Iperf_device_if, 
                           platform_serialno: data?.result?.[each]?.platform_serial, 
                           platform_heartbeat: data?.result?.[each]?.platform_heartbeat,
                           "active_image_slot": data?.result?.[each]?.active_image_slot,
                           "iperf_acceleration": data?.result?.[each]?.iperf_acceleration,
                          in_band_management:data?.result?.[each]?.in_band_management});

          if(this.selectedDevice[0]?.id==each){
          this.selectedDevice = [{ serial: each, id: each,deviceid: each, serial_name: `${each} (${data?.result?.[each]?.device_name})`, 
                                    name: data?.result?.[each]?.device_name, 
                                    modems: data?.result?.[each]?.modems, 
                                    device_if: data?.result?.[each]?.Iperf_device_if, 
                                    platform_serialno: data?.result?.[each]?.platform_serial, 
                                    platform_heartbeat: data?.result?.[each]?.platform_heartbeat,
                                    "active_image_slot": data?.result?.[each]?.active_image_slot,
                                    "iperf_acceleration": data?.result?.[each]?.iperf_acceleration,
                                  in_band_management:data?.result?.[each]?.in_band_management}]
        }
          // Check if heartbeat is less than 1 minute
          if (heartbeat && (new Date().valueOf() - heartbeat) <= 60000 && !this.selectedDevice[0] && !this.previousSelectedDevice) {
            // If heartbeat is less than 1 minute and no selected device yet, set this device as selected
            this.selectedDevice[0] = deviceArr[deviceArr.length - 1];
          }

          ind++
        }
        // If no device with heartbeat less than 1 minute is found, set the first device as selected
        //console.log(this.selectedDevice);
        if (!this.selectedDevice[0] && deviceArr.length > 0) {
          this.selectedDevice = this.previousSelectedDevice ? [this.previousSelectedDevice] : [deviceArr[0]];
        }
        // const userDevices = localStorage.getItem('user_devices') != 'undefined' && JSON.parse(window.localStorage.getItem('user_devices'));
        // if (userDevices&&userDevices.length > 0) {
        //   let filteredDevices = []
        //   userDevices.forEach(device => {
        //     // Find the matching object in 'sourceProducts'
        //     const matchingProductIndex = deviceArr.findIndex(product => product.id == device);
        //     if (matchingProductIndex !== -1) {
        //       // Remove the object from 'sourceProducts' and add it to 'targetProducts'
        //       filteredDevices.push(deviceArr[matchingProductIndex]);
        //     }
        //   });
        //   this.devices = filteredDevices;
        // } else {
        //   this.devices = deviceArr;

        // }
         this.devices = deviceArr;
        this.walktestServices.checkModemStatus([this.selectedDevice?.[0]?.serial]).subscribe((deviceStatusData:any)=>{
          setTimeout(() => {
            const deviceid = this.allDevices?.[this.selectedDevice?.[0]?.serial]?.modems?.[0]?.deviceid
            let deviceData = deviceStatusData?.result?.[deviceid]
            this.deviceStatus = deviceData?.['online'] == 'Yes' && deviceData?.['status'] == 'Eligible'
          }, 1000);
        
        });
        if(!this.isDetailedReport){
          //console.log(this.selectedDevice, "called getdevicees");
          this.authService.sendDeviceInfo(this.selectedDevice);
        }
      }
    });
    this.allsubscriptions.push(getDeviceName$);
  }

  ChangeDevice() {
    if(this.isDetailedReport){
      //console.log(this.selectedDevice, "called changedevice");
      this.authService.sendDetailedReprotDeviceInfo(this.selectedReportDevice);
    }else{
      //console.log(this.selectedDevice, "called changedevice");
      this.authService.sendDeviceInfo(this.selectedDevice);
      this.selectedDevice?.[0]?.serial&&this.walktestServices.checkModemStatus([this.selectedDevice?.[0]?.serial]).subscribe((deviceStatusData:any)=>{
        const deviceid = this.allDevices?.[this.selectedDevice?.[0]?.serial]?.modems?.[0]?.deviceid
        let deviceData = deviceStatusData?.result?.[deviceid]
        this.deviceStatus = deviceData?.['online'] == 'Yes' && deviceData?.['status'] == 'Eligible'
       
      });
      this.previousSelectedDevice = this.selectedDevice[0];
      // Store previousSelectedDevice in localStorage
      localStorage.setItem('previousSelectedDevice', JSON.stringify(this.previousSelectedDevice));
      // //console.log("previousSelectedDevice", this.previousSelectedDevice);
    }
  }


  getMaps(check?: any, check1?:any) {
    //console.log(check, check1,"k kkkkk kk")
    if(!this.isDetailedReport){
      const maps = []
      let allMaps$ = this.walktestServices.getMaps().subscribe((res: any) => {
        // //console.log(res);
        res?.result?.hits && res?.result?.hits.map((each: any, index: number) => {
          if (each?._source?.map_type == 'Outdoor') {
            maps.push({
              isHeader:false,
              id: each?._id, name: each?._source?.mapname, catagory: each?._source?.map_type == 'Composite' ? 'Composite' : each?._source?.map_type == 'Outdoor' ? 'Outdoor' : 'Indoor', file: each?._source?.imgname, campus: each?._source?.campus, mapid: each?._id,
              north_east: each?._source?.north_east, south_west: each?._source?.south_west, scale: each?._source?.scale, area: each?._source?.area
            })
          } else if (each?._source?.imgname) {
            maps.push({
              isHeader:false,
              id: each?._id, name: each?._source?.mapname, catagory: each?._source?.map_type == 'Composite' ? 'Composite' : each?._source?.map_type == 'Outdoor' ? 'Outdoor' : 'Indoor', file: each?._source?.imgname, campus: each?._source?.campus, mapid: each?._id,
              north_east: each?._source?.north_east, south_west: each?._source?.south_west, scale: each?._source?.scale, area: each?._source?.area
            })
  
          }
        })
        // maps.splice(0, 0, { id: 100003232144, name: 'Outdoor Map', file: '-', campus: '-', mapid: 'outdoor', group: 'Outdoor Map', catagory: "Outdoor" })
        this.maplist = maps;
        this.walktestMaplist=maps
        this.walktestMaplist = [
          { id: "-1", name: '+ Add New Map', isHeader: true },
          ...this.maplist
        ]; 

console.log("this.walktestMaplist",this.walktestMaplist)	


        this.findValidMap(maps, 0).then((response: any) => {
          console.log("resssssssssss",this.mapResponse,response)
          if(this.mapResponse && check1==9){ // this is for map response when trigger action from live walktest dropdown action 9
            if(this.mapResponse?.imgname){  // check image name in map response and then assign it to selected map
              this.selectedMap =this.maplist.filter((map: any) => map?.name == this.mapResponse?.mapname);
            }else{  
              this.selectedMap = check1==9 ? this.previousSelectedMap  : response;

            }
          }else{
            this.selectedMap = check ? response : this.previousSelectedMap ? this.previousSelectedMap : response;
          }

          
          this.changeMap();
        })
  
        // this.selectedMap = [maps?.[0]]
        // this.changeMap();
      })
      this.allsubscriptions.push(allMaps$);
    }else{
      const maps:any = 
      [];
      //  [{id:"outdoor", name:"Outdoor", value:"Outdoor Map", catagory:"Outdoor"}];
      if (check?.startDate && check?.endDate) {
        this.selectedDevice=[]
        let noWifiMaps = this.walktestServices.getReportMaplist(check)
        .pipe(catchError((error: any) => {
          //console.log(error);
          if(error?.status==404){
            this.fetchingMaps = false;
          }
          return of({});
           })
         );
  
         let withWifi = this.walktestServices.getReportMaplistBase(check)
         .pipe(catchError((error: any) => {
           //console.log(error);
           if(error?.status==404){
             this.fetchingMaps = false;
           }
           return of({});
            })
          )
         this.fetchingMaps = true;

         forkJoin({withWifi,noWifiMaps}).subscribe((res:any)=>{
          //console.log(res);
          const commonMaps = {};
          let list = res?.noWifiMaps?.result||[];
          let listBase = res?.withWifi?.result||[];
          list.map(each=>{
            Object.assign(commonMaps,{[each?.mapid]:each});
          })
          listBase.map(each=>{
            if(each){
              each["test_type"] = "wifi"
            }
            Object.assign(commonMaps,{[each?.mapid]:each});
          })
  
          let commonMapsList = Object.values(commonMaps);
         //console.log(commonMapsList);
  
         commonMapsList && commonMapsList.map((each: any, index: number) => {
          // const filteredMap = this.allMaps?this.allMaps.filter((map: any) => map?._id == each?.mapid):[];
          let catagory = each?.map_type=="PDF"?"Indoor":each?.map_type=="Composite"?"Composite":"Outdoor";
          if (each?.imgname) { 
            maps.push({  id: each?.mapid,catagory:catagory, 
                                           name: each?.mapname, 
                                           file: each?.imgname, 
                                           scale: each?.scale, 
                                           area: each?.area, 
                                           mapid: each?.mapid,
                                          //  north_east:filteredMap[0]?._source.north_east, 
                                          //  south_west:filteredMap[0]?._source?.south_west,
                                           isWifi:each?.test_type
                                           })
                                 }
        })
        this.maplist = maps;
        this.selectedMap = maps?.[0] ? [maps?.[0]] : [];
        this.changeMap();
        this.fetchingMaps = false;
  
        })


        // this.walktestServices.getReportMaplist(check).subscribe((res: any) => {
        //   //console.log(res)
        //   res?.result && res?.result.map((each: any, index: number) => {
        //     if (each?.imgname) { maps.push({ id: each?.mapid, 
        //                                      name: each?.mapname, 
        //                                      file: each?.imgname, 
        //                                      catagory: each?.imgname? 'Indoor' :'Outdoor',
        //                                      scale: each?.scale, 
        //                                      area: each?.area, 
        //                                      mapid: each?.mapid }) }
        //   })
        //   this.maplist = maps
        //   this.selectedMap = maps?.[0] ? [maps?.[0]] : []
        //   this.changeMap()
        //   this.fetchingMaps = false;
        // })
      }
    }

  }

  findValidMap(maplist: any[] = [], index: number) {
    return new Promise((resolve: any, reject: any) => {
      this.walktestServices.getMapFile(maplist?.[index]?.file).pipe(catchError((error: any) => {
        if (index + 1 <= maplist.length - 1) {
          // //console.log("called repeate", index + 1)
          this.findValidMap(maplist, index + 1).then(res => {
            resolve(res);
          })
        }
        return throwError("no file found");
      })).subscribe(blob => {
        // //console.log("called success")
        resolve([maplist?.[index]])
      })

    })
  }

  changeEventType($event) {
    // //console.log(this.selectedEventType);
    this.authService.sendEventInfo(this.selectedEventType);
  }
  changeTestType($event) {
    this.authService.sendTestType($event?.[0]?.name);
  }


    getDevicesReport() {
      //console.log("called")
      this.fetchingDevices=true;
      clearTimeout(this.deviceApiCallThrottlingtimeoutCopy)
      this.deviceApiCallThrottlingtimeoutCopy = 
      setTimeout(() => {
        clearTimeout(this.deviceApiCallThrottlingtimeoutCopy);
        //console.log('mmmmmmm');
  
        let noWifi = this.walktestServices.getDivecesList(this.selectedMap, { startDate: new Date(this.datetimeRange?.start).valueOf(), endDate: new Date(this.datetimeRange?.end).valueOf() })
        .pipe(catchError((error: any) => {
          //console.log(error);
          if(error?.status==404){
            this.fetchingDevices = false;
          }
          return of({});
           })
         );
  
         let withWifi = this.walktestServices.getDivecesBase(this.selectedMap, { startDate: new Date(this.datetimeRange?.start).valueOf(), endDate: new Date(this.datetimeRange?.end).valueOf() })
         .pipe(catchError((error: any) => {
           //console.log(error);
           if(error?.status==404){
             this.fetchingDevices = false;
           }
           return of({});
            })
          )
  
          forkJoin({withWifi, noWifi}).subscribe((res:any)=>{
            //console.log(res, this.allDevices);
            const commonDevices = {};
            const baseDeviceMap={};
            let list = res?.noWifi?.result||[];
            let listBase = res?.withWifi?.result||[];
            listBase.map(each=>{
              Object.assign(baseDeviceMap,{[each?.deviceid]:each});
              Object.assign(commonDevices,{[this.allDevices?.[each?.deviceid]?.['serial']]:each});
              commonDevices[this.allDevices?.[each?.deviceid]?.['serial']]["test_type"] = "wifi"
              commonDevices[this.allDevices?.[each?.deviceid]?.['serial']]["baseId"] = this.allDevices?.[each?.deviceid]?.platform_serial;
              commonDevices[this.allDevices?.[each?.deviceid]?.['serial']]["deviceid"] = this.allDevices?.[each?.deviceid]?.['serial'];
            })
  
            list.map(each=>{
              //console.log(this.allDevices?.[each?.deviceid]);
              Object.assign(commonDevices,{[each?.deviceid]:each});
              if(baseDeviceMap?.[this.allDevices?.[each?.deviceid]?.platform_serial]){
                   commonDevices[each?.deviceid]["test_type"] = "wifi"
                   commonDevices[each?.deviceid]["baseId"] = this.allDevices?.[each?.deviceid]?.platform_serial;
              }
            })
  
            let commondevicesList = Object.values(commonDevices);
           //console.log(commondevicesList);
  
           const dataarray = []
           commondevicesList && commondevicesList.map((each: any, index: number) => {
             dataarray.push({ id: index + 1, 
                              name: each?.name, 
                              deviceid: each?.deviceid, 
                              serial_name: `${each?.deviceid} (${each?.name})`,
                              isWifi:each?.test_type=="wifi",
                              baseId:each?.baseId})
           })
           this.devicesReprt = dataarray;
           this.fetchingDevices = false;
           //console.log(dataarray);
           if(dataarray.length>0)
             {this.selectedReportDevice = [dataarray[0]];}
           else{
             this.selectedReportDevice = []
           }
             if(this.isDetailedReport){
               //console.log(this.selectedReportDevice)
               //console.log(this.selectedDevice, "called report devices");
               this.authService.sendDetailedReprotDeviceInfo(this.selectedReportDevice);
             }
         }
          )
      }, 500)
  
  
    }

  getReportDevices() {
    this.getDevicesReport();
    // this.fetchingDevices=true;
    // clearTimeout(this.deviceApiCallThrottlingtimeout)
    // this.deviceApiCallThrottlingtimeout = setTimeout(() => {
    //   //console.log('mmmmmmmppppppppppppppp')
    //   this.walktestServices.getDivecesList(this.selectedMap, { startDate: new Date(this.datetimeRange?.start).valueOf(), endDate: new Date(this.datetimeRange?.end).valueOf() }).subscribe((data: any) => {
    //     const dataarray = []
    //     data.result && data.result.map((each: any, index: number) => {
    //       dataarray.push({ id: index + 1,serial:each?.deviceid, name: each?.name, deviceid: each?.deviceid, serial_name: `${each?.deviceid} (${each?.name})`, modems:[] })
    //     })
    //     // this.devices = dataarray;
    //     this.devicesReprt = dataarray;
    //     // //console.log(this.devices);
    //     if(dataarray.length>0)
    //       {this.selectedReportDevice = [dataarray[0]];}
    //     else{
    //       this.selectedReportDevice = []
    //     }
    //       if(this.isDetailedReport){
    //         //console.log(this.selectedReportDevice)
    //         //console.log(this.selectedDevice, "called report devices");
    //         this.authService.sendDetailedReprotDeviceInfo(this.selectedReportDevice);
    //       }
    //       this.fetchingDevices=false;
    //   });
    // }, 500)
  }
  onAddNewMap(){
this.OpenPopup('addNewMapFromWalktest');
  }
  changeMap($event?:any, showToast?:boolean) {
 if ($event?.[0]?.id !=-1) {  // for live walktest set first map as default as add new map so its id is -1
      if(showToast){
        this.selectedMap&&this.selectedMap?.[0]?
        this.toast.info("Loading map, please wait..."): this.toast.warning("No Map is selected!")
      }
      let out = setTimeout(()=>{
        // console.log(JSON.stringify(this.selectedMap));
        this.authService.sendMapInfo([...this.selectedMap]);
        this.previousSelectedMap = this.selectedMap;
        localStorage.setItem('previousSelectedMap', JSON.stringify(this.previousSelectedMap));
        if(this.isDetailedReport){
              this.getReportDevices();
            }
        clearTimeout(out);
      },1500)
    }else{
      this.selectedMap=null;
    }

  }

  openImportPopup() {
    this.matDialogRef3 = this.dialog.open(ImportPopupComponent, {
      data: {},
      disableClose: true
    });
  }
  handleNotificationSubmit() {
    this.authService.sendSubmitNotification.next({ eventType: this.selectedEventType, deviceId: this.selectedNotificationDevice });
  }
  mapResponse:any;
  loadMaps:boolean=false;
  OpenPopup(type?: string) {
    this.matDialogRef = this.dialog.open(FloorMapAddModelComponent, {
      data: {from:type},
      disableClose: true
    });
    let dialogSub$ = this.matDialogRef.afterClosed().subscribe(res => {
      // console.log("responseeeee",res)
      this.authService.refreshData();
      if(type == "addNewMapFromWalktest"){
        this.loadMaps=true;
        setTimeout(() => {
          this.loadMaps=false;
        }, 1000);
        this.mapResponse = res;
        // console.log("addNewMap")
        this.getMaps(true, "9");
      }
      setTimeout(() => {
        this.authService.refreshData();
      }, 2000);
    });

    this.allsubscriptions.push(dialogSub$)

    // GroupsManagerAddModelComponent
  }
  OpenPopupNewGroup() {
    this.matDialogRef2 = this.dialog.open(GroupsManagerAddModelComponent, {
      data: {},
      disableClose: true
    });


    let dialogRef2$ = this.matDialogRef2.afterClosed().subscribe(res => {
      this.authService.refreshData();
    });

    this.allsubscriptions.push(dialogRef2$)

  }
  OpenPopupNewProfile() {
    this.matDialogRef4 = this.dialog.open(RoleAddComponent, {
      data: {},
      disableClose: true
    });


    let dialogRef4$ = this.matDialogRef4.afterClosed().subscribe(res => {
      this.authService.refreshData();
    });

    this.allsubscriptions.push(dialogRef4$);
    // const dialogRef = this.dialog.open(GroupsManagerAddModelComponent, {
    //   data: {} ,
    // });

    // dialogRef.afterClosed().subscribe(result => {
    //   //console.log('The dialog was closed',result);
    // });
    // if (this.isAllow == false) {
    //   this.isAllow = true;
    //   this.authService.triggerModel(true);

    //   setTimeout(() => {
    //     this.isAllow = false;
    //   }, 3000);

    // }
  }
  OpenPopupNewUser() {
    let matDialogRef = this.dialog.open(UserAddComponent, {
      data: {},
      disableClose: true
    });


     let dialogRef2$  = matDialogRef.afterClosed().subscribe(res => {
      this.authService.refreshData();
    });

    this.allsubscriptions.push(dialogRef2$)
  }
  OpenMNOAddPopup() {
    this.matDialogRef1 = this.dialog.open(MnoMappingEditComponent, {
      data: { params: '' },
      disableClose: true
    });
     let modelRef1$ = this.matDialogRef1.afterClosed().subscribe(res => {
      this.authService.refreshData();
    });
    this.allsubscriptions.push(modelRef1$);
  }

  handleViewType($event, check:any){
      //console.log("event",$event.target.checked, check);
          this.commonServices.testViewTypeSubject.next({val:check, status:$event.target.checked});
        
  }
  

  openConfigureModal() {
    const matDialogRef = this.matDialog.open(MnoMapModelComponent, {
      data: {  },
      disableClose: true
    });
    // this.getFloorMapData();
    matDialogRef.afterClosed().subscribe(res => {
     

    
    });
  }

 
  sliceModems:any=[];
  deviceDetails:any={};
  deviceStatusInfo:any;
  kuzzleMachinTimeDiff = 0;
  selectedTab: string = '4G';
   handleBandInfoCHeck($event,item){
    this.deviceDetails=item
    //console.log("deviceDetails",this.deviceDetails);
    $event.stopPropagation();
    this.openBandlockInfo={check:true, size:'lg'} ;
    if(item?.deviceid){
    this.commonServices.getDeviceStatus(item.deviceid).subscribe((res:any)=>{
      //console.log("event",res);
      this.deviceStatusInfo= res?.result?._source?.heartbeat_ts ? (new Date().valueOf() + this.kuzzleMachinTimeDiff - res?.result?._source?.heartbeat_ts <= 60000) ? 'online' : 'offline' : 'offline',
this.commonServices.getBandLockTempaltes(item.deviceid).subscribe((res2:any)=>{
  const imeiTemplateMap =   this.mapImeiToTemplates(res2);
  //console.log("modems")
     this.sliceModems =  this.assignTemplateNamesToModems(res?.result?._source?.xedge_slice?.modem, imeiTemplateMap);
     //console.log("slice Mdemsss",this.sliceModems)
    })
    })
  }
  }
  closeBandlockInfo(){
    this.openBandlockInfo={check:false, size:'lg'} ;

  }


  mapImeiToTemplates(jsonData: any) {
    const imeiTemplateMap: Record<string, Set<string>> = {};
  
    for (const hit of jsonData.result.hits) {
      const { devices = [], template_name } = hit._source;
      for (const device of devices) {
        const imei = device.imei;
        if (!imeiTemplateMap[imei]) {
          imeiTemplateMap[imei] = new Set();
        }
        imeiTemplateMap[imei].add(template_name);
      }
    }
  
    // Convert Sets to Arrays
    const result: Record<string, string[]> = {};
    for (const imei in imeiTemplateMap) {
      result[imei] = Array.from(imeiTemplateMap[imei]);
    }
  
    return result;
  }
   assignTemplateNamesToModems(
    modems: any[],
    imeiTemplateMap: Record<string, string[]>
  ): any[] {
    return modems.map(modem => {
      const imei = modem.imei;
      const templates = imeiTemplateMap[imei] || []; // fallback to [] if no match
      return {
        ...modem,
        template_names: templates // adds template_names as an array
      };
    });
  }
  goToTAssets(page){
    console.log(this.selectedDevice[0]);
    this.router.navigateByUrl('/assets', {
      state: { id: 1, device: this.selectedDevice[0], isNavigatedfromTest: true, page:page },
    });
  }  

  goToTelemetry(page){
    this.router.navigateByUrl('/telemetry', {
      state: { id: 1, device: this.selectedDevice[0], isNavigatedfromTest: true, page:page },
    });
  }  
  goToWalktest(page) {
    this.router.navigateByUrl('/live-walk-test', {
      state: { id: 1, device: this.selectedDevice[0], isNavigatedfromTest: true, page:page },
    });
  }

    redirectFromTo(page:any, toUrl?:any) {
    this.router.navigateByUrl(`${toUrl}`, {
      state: { id: 1, device: this.selectedDevice[0], isNavigatedfromTest: true, page:page },
    });
  }
}